export default{
    computed:{
        reimbursementTypeImportList(){
            return[
                { value: 9, label: '账单索赔-库内费用'},
                { value: 10, label: '账单索赔-尾程费用' },
                { value: 33, label: '尾程索赔'},
                ]
        },
        //索赔单状态
        statusList(){
            return [
				{ value: 1, label: '草稿' ,theme: 'gray'},
                { value: 2, label: '待审核' ,theme: 'warning'},
                { value: 3, label: '审核拒回' ,theme: 'error'},
				{ value: 4, label: '处理中' ,theme: 'primary'},
				{ value: 5, label: '平台完成', theme: 'success' },
                { value: 6, label: '已取消', theme: 'error' },
                { value: 7, label: '赔付完成' ,theme: 'success'},
            ]
        },
       
        reimbursementReasonList(){
            return[
            { value: 1, label: '库存短少'},
            { value: 2, label: '订单异常平台罚款'},
            { value: 3, label: '仓库发错货'},
            { value: 4, label: 'Label Created' },
            { value: 5, label: 'Delivered but not Received' },
            { value: 6, label: 'Shipment Damaged' },
            { value: 7, label: 'Shipment Missing Contents/Pieces' },
            { value: 8, label: 'Lost in Transit' },
            { value: 9, label: '库内费用'},
            { value: 10, label: '尾程费用'},
            { value: 11, label: '库存接收短少'},
            { value: 12, label: '入库卸柜超时'},
            { value: 13, label: '库内破损'}
            ]
        },
        trackingTypeList(){
            return[
            { value: 1, label: '发货Tracking'},
            { value: 2, label: '退货Tracking'}
            ]
        },
        //索赔类型
        reimbursementTypeList(){
            return[
                { value: 1, label: '库内索赔', child: [
                    { value: 1, label: '库存短少'},
                    { value: 2, label: '订单异常平台罚款'},
                    { value: 3, label: '仓库发错货',child:[
                        { value: 1, label: '产品退回原仓'},
                        { value: 2, label: '产品不退回'},
                    ]},
                    { value: 13, label: '库内破损'},
                ] },
                { value: 2, label: '尾程索赔', child: [
                    { value: 4, label: 'Label Created' },
                    { value: 5, label: 'Delivered but not Received' },
                    { value: 6, label: 'Shipment Damaged' },
                    { value: 7, label: 'Shipment Missing Contents/Pieces' },
                    { value: 8, label: 'Lost in Transit' },
                   
                ] },
                { value: 3, label: '账单索赔' ,child:[
                    { value: 9, label: '库内费用',child:[
                        { value: 1, label: '仓库作业费'},
                        { value: 2, label: '仓储费'},
                        { value: 3, label: '包材费'},
                        { value: 4, label: '增值服务费'},
                    ] },
                    { value: 10, label: '尾程费用',child:[
                        { value: 5, label: '基础费率' },
                        { value: 6, label: 'Zone' },
                        { value: 7, label: 'AHS' },
                        { value: 8, label: 'OS' },
                        { value: 9, label: 'unauthorized os' },
                        { value: 10, label: 'Other' },
                    ] }
                ]},
                { value: 4, label: '头程索赔', child: [
                    { value: 11, label: '库存接收短少'},
                    { value: 12, label: '入库卸柜超时'}
                ] },
            ]
        },
      

        
       
    }
    
}